import classfeedService from "../services/classfeed.service";
import ACTION_TYPE from "./type.action";

export const getAllPost = (classId) => async dispatch => {
  let posts = await classfeedService.fecthAllPosts(classId);
  dispatch({
    type: ACTION_TYPE.GETALL_POSTS,
    payload: posts
  });
};

export const getAllPostWithFilter = (classId,startDate,endDate) => async dispatch => {
  let posts = await classfeedService.fecthAllPostsWithFilter(classId,startDate,endDate);
  dispatch({
    type: ACTION_TYPE.GETALL_POSTS,
    payload: posts
  });
};

export const clearAllPosts = () => dispatch => {
  dispatch({
    type: ACTION_TYPE.CLEARALL_POSTS
  });
};

export const createPost = (classId,text,creatorId) => async dispatch => {
  await classfeedService.create(classId,text,creatorId);
};

export const updatePost = (postId, text) => async dispatch => {
  await classfeedService.update(postId, text);
  dispatch({
    type: ACTION_TYPE.UPDATE_POST,
    payload: {postId:postId,
              text:text
    }
  });
};

export const readPost = postId => async dispatch => {
  let post = await classfeedService.read(postId);
  // dispatch({
  //   type: ACTION_TYPE.EDIT_POST,
  // });
};

export const deletePost = (postId) => async dispatch => {
  await classfeedService.delete(postId);
  
  dispatch({
    type: ACTION_TYPE.DELETE_POST,
    payload: postId
  });
};

export const deletePostByNotification = (postId) => async dispatch => { 
  dispatch({
    type: ACTION_TYPE.DELETE_POST,
    payload: postId
  });
};

export const createComment = (postId,text,creatorId,classId) => async dispatch => {
  await classfeedService.createComment(postId,text,creatorId,classId);
  let post = await getPost(classId,postId)
  dispatch({
    type: ACTION_TYPE.CREATE_COMMENT,
    payload: post
  });
};

export const updateComment = (postId,commentId, text,classId) => async dispatch => {
  await classfeedService.updateComment(commentId, text);
  let post = await getPost(classId,postId)
  dispatch({
    type: ACTION_TYPE.UPDATE_COMMENT,
    payload: post
  });
};

export const readComment = postId => async dispatch => {
  let comment = await classfeedService.readComment(postId);
};

export const deleteComment = (postId,commentId,classId) => async dispatch => {
  await classfeedService.deleteComment(commentId);
  let post = await getPost(classId,postId)
  dispatch({
    type: ACTION_TYPE.DELETE_COMMENT,
    payload: post
  });
};

export const addPost = (postId,classId) => async dispatch => {
  let post = await getPost(classId,postId)
  dispatch({
    type: ACTION_TYPE.ADD_POST_BYNOTIFICATION,
    payload: post
  });
};

export const notificationUpdate = (postId,classId) => async dispatch => {
  let post = await getPost(classId,postId)
  dispatch({
    type: ACTION_TYPE.NOTIFICATION_UPDATE,
    payload: post
  });
};


const getPost=async(classId,postId)=>{
  let posts = await classfeedService.fecthAllPosts(classId);
  let post = posts.filter(
    post => post.id === postId
    );
  return post[0]
}